export default __webpack_public_path__ + "Asset_Basemap_2D.5816f25d4524042925c5812ea159e38f.jpg";